import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { CREDIT_REPAIR_VERTICAL } from 'types/mrph.vertical.constants';

export const useCreditRepairExpertTipHook = eventHandler => {
  const onClickCall = () => {
    eventHandler(CLICK, {
      'Click Type': 'Phone Number 844-764-1547',
      Vertical: CREDIT_REPAIR_VERTICAL,
    });
  };

  return {
    onClickCall,
  };
};
